<template>
  <v-container grid-list-md fluid>
    <!--Index-->
    <v-layout v-if="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <tr :style="{ backgroundColor: getRGBColor(props.item.urgencia) }">
              <td align="center">{{ props.item.id }}</td>
              <td>{{ props.item.titulo }}</td>
              <td>{{ props.item.descricao }}</td>
              <td align="center">{{ props.item.status }}</td>
              <td align="center">{{ props.item.tipo }}</td>
              <td align="center">{{ props.item.urgencia }}</td>
              <td>{{ props.item.user.name }}</td>
              <!-- <td>{{ props.item.imagem1 }}</td>
        <td>{{ props.item.imagem2 }}</td>
        <td>{{ props.item.imagem3 }}</td>
        <td>{{ props.item.imagem4 }}</td>
        <td>{{ props.item.imagem5 }}</td> -->
              <td align="center">{{ props.item.created_at | formatDateTime }}</td>
              <td align="center">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mx-0"
                  @click="deleteItem(props.item, props.item.id, true)"
                  v-if="props.item.id_texto != $auth.user().anobase.id_texto"
                >
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-layout v-else wrap justify-center align-center>
      <v-flex xs12>
        <v-tooltip bottom>
          <template v-if="view == 3" v-slot:activator="{ on }">
            <span class="headline" v-on="on">#{{ editedItem.id }}-</span>
          </template>
          <span>Identificador</span>
        </v-tooltip>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          name="titulo"
          :label="translate('table.' + entity + '.field.titulo')"
          v-model="editedItem.titulo"
          :error-messages="errors.collect('titulo')"
          v-validate="'required'"
          data-vv-as="Título"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          name="descricao"
          multi-line
          :label="translate('table.' + entity + '.field.descricao')"
          v-model="editedItem.descricao"
          :error-messages="errors.collect('descricao')"
          v-validate="'required'"
          data-vv-as="Descrição"
        ></v-textarea>
      </v-flex>
      <v-flex xs12 md6>
        <v-select
          name="status"
          :items="['Aberto', 'Em andamento', 'Fechado']"
          :label="translate('table.' + entity + '.field.status')"
          v-model="editedItem.status"
          :error-messages="errors.collect('status')"
          v-validate="'required'"
          data-vv-as="Status"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6>
        <v-select
          name="tipo"
          :items="['Implementação Corretiva', 'Implementação Evolutiva']"
          :label="translate('table.' + entity + '.field.tipo')"
          v-model="editedItem.tipo"
          :error-messages="errors.collect('tipo')"
          v-validate="'required'"
          data-vv-as="Tipo"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <v-slider
          name="urgencia"
          label="Urgência"
          v-model="editedItem.urgencia"
          :max="10"
          thumb-label
          ticks="always"
        ></v-slider>
      </v-flex>

      <!-- Inputs de arquivos -->
      <!-- <v-flex xs12>
        <input type="file" @change="handleFileUpload(1)" />
      </v-flex>
      <v-flex xs12>
        <input type="file" @change="handleFileUpload(2)" />
      </v-flex>
      <v-flex xs12>
        <input type="file" @change="handleFileUpload(3)" />
      </v-flex>
      <v-flex xs12>
        <input type="file" @change="handleFileUpload(4)" />
      </v-flex>
      <v-flex xs12>
        <input type="file" @change="handleFileUpload(5)" />
      </v-flex> -->

      <!-- <v-flex xs12>
        <quill-editor v-model="editedItem.descricao" :options="editorOption"></quill-editor>
      </v-flex> -->
    </v-layout>

    <v-btn v-if="view === 1" color="primary" dark fab fixed bottom right @click="create">
      <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
    </v-btn>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-btn v-model="fab" slot="activator" fab color="primary" dark :disabled="saving" :loading="saving" @click="save()">
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
          <v-icon>{{ this.translate("system.button.save.icon") }}</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :disabled="saving" :loading="saving" @click="saveNew()">
            <v-icon>{{ this.translate("system.button.save_new.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_new.title") }}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-btn v-if="view === 3" color="primary" dark fab :disabled="saving" :loading="saving" @click="save()">
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
import crud from "../../mixin/crud";
import acl from "../../mixin/acl";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  mixins: [crud, acl],
  data: () => ({
    fab: null,
    entity: "suporte",
    editorOption: {
      // Algumas opções de configuração
    },
  }),
  methods: {
    getRGBColor(value) {
      const startColor = [251, 221, 221]; // RGB de #fbdddd
      const endColor = [253, 117, 117]; // RGB de #fd7575
      const diffColor = endColor.map((end, index) => end - startColor[index]);
      const increment = diffColor.map((diff) => diff / 9);
      const color = startColor.map((start, index) => Math.round(start + increment[index] * value));
      return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
    },
    uploadFiles(index) {
      const fieldName = `file${index}`;
      let formData = new FormData();
      Array.from(this.$refs[fieldName].files).forEach((file) => {
        formData.append("files[]", file);
      });

      this.$http
        .post("api/upload_suporte", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.initialize();
    this.editedItem = { empresa_id: this.$auth.user().empresa_id, user_id: this.$auth.user().id };
    this.defaultItem = { empresa_id: this.$auth.user().empresa_id, user_id: this.$auth.user().id };
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.id"),
          value: "id",
          width: "5%",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.titulo"),
          value: "titulo",
          width: "15%",
        },
        {
          text: this.translate("table." + this.entity + ".field.descricao"),
          value: "descricao",
          width: "25%",
        },
        {
          text: this.translate("table." + this.entity + ".field.status"),
          value: "status",
          width: "10%",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.tipo"),
          value: "tipo",
          width: "10%",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.urgencia"),
          value: "urgencia",
          width: "5%",
          align: "center",
        },
        {
          text: this.translate("table." + this.entity + ".field.user_id"),
          value: "user_id",
          width: "10%",
        },
        // { text: this.translate("table." + this.entity + ".field.imagem1"), value: "imagem1" },
        // { text: this.translate("table." + this.entity + ".field.imagem2"), value: "imagem2" },
        // { text: this.translate("table." + this.entity + ".field.imagem3"), value: "imagem3" },
        // { text: this.translate("table." + this.entity + ".field.imagem4"), value: "imagem4" },
        // { text: this.translate("table." + this.entity + ".field.imagem5"), value: "imagem5" },
        {
          text: this.translate("table." + this.entity + ".field.created_at"),
          value: "created_at",
          width: "10%",
          align: "center",
        },
        {
          text: this.translate("system.table.action"),
          sortable: false,
          align: "center",
          width: "10%",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Suporte.vue